// extracted by mini-css-extract-plugin
export default {"container":"section_container__tHlAh"};